export class Lote{
    public constructor(
        public codigo: String = "",
        public fecha_elaboracion: string = "",
        public fecha_expiracion : string = "",
        public cantidad:number = 0,
        public inventario_id = String,
        public fecha_emision: any = "",
    ){
        //
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/lote.ts